import Vue from 'vue';

export default class GridHelper {
    public static renderNumber(h, value) {
        return h('td', Vue.filter('number-format')(value));
    }
}
